import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password.component';

const childRoutes: Routes = [
    {
        path: 'reset/:token',
        component: ResetPasswordComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(childRoutes)],
    exports: [RouterModule],
})
export class ResetPasswordRoutingModule { }
